import React from "react";
import FirmContactRow from "./FirmContactRow";

export default function FCList(props) {

  let line1 = ""
  let line2 = ""
  let line3 = ""

  if (props.address && props.address.line1) {
    line1 = props.address.line1
    if (props.address.line2){
      line2 = props.address.line2
      line3 = props.address.city + ", " + props.address.stateCode + " " + props.address.postalCode
    } else {
      line2 = props.address.city + ", " + props.address.stateCode + " " + props.address.postalCode
    }
  }

  function isNumber(num){
    return !isNaN(parseFloat(num)) && isFinite(num);
  }
  let identifier = props.searchValue;
  if (isNumber(identifier)) {
      identifier = identifier + ' - (' + props.fcData[0].eid + ')'
  }

  let firmName = "unknown"
  if (props.fcData[0].name) {
    firmName = props.fcData[0].name.lastName
  } 

  const eid = props.fcData[0].eid
  const firmContacts = props.fcData[0].firmContacts
  let action = 'Request a new firm contact'
  if (props.admin) {
    action = 'Build a new firm contact'
  }
  function handleSubmit() {
    props.setData(null)
  }
  function handleAdd() {
    props.setFcAddMode(true)
    props.setFcEditMode(false)
    props.setGlobalAlert({
        id: "",
        type: "",
        message:
          "",
        hidden: true,
    })
  }

  function filter() {
    // Declare variables
    var input, filter, table, tr, td, i, txtValue;
    input = document.getElementById("filterInput");
    filter = input.value.toUpperCase();
    table = document.getElementById("fcListing");
    tr = table.getElementsByTagName("tr");
  
    // Loop through all table rows, and hide those who don't match the search query
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName("td")[0];
      if (td) {
        txtValue = td.textContent || td.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";
        }
      }
    }
  }

  return (
    <div>
      <h3>Firm Information</h3>
      <table><tbody>
      <tr><td className="col-10"><strong>Firm Name : </strong>{`${firmName}`}</td>
      <td>{`${line1}`}</td>
      </tr>
      <tr>
      <td className="col-10"><strong>Firm Identifier : </strong>{`${identifier}`} </td>
      <td>{`${line2}`}</td>
      </tr>
      <tr>
      <td className="col-10"></td>
      <td>{`${line3}`}</td>
      </tr>
      </tbody></table>
      <br></br>
      <div className='pds-color-font-core-1 pds-typography-body-20'>List of Firm Contacts<br></br></div>
      Type something in the input field to search the table for first names, last names or enterprise ids:
      <div className='pds-dataTable'>

        <div className="pds-dataTable-header">
          <div className="pds-searchInput pds-dataTable-smart-search">
            <input aria-label="Filter table data search bar" className="search inputSearch pds-input-small" type="search" id="filterInput" onKeyUp={filter} placeholder="What are you looking for?" />
            <button type="submit" aria-label="Search" aria-disabled="true"></button>
          </div>
        </div>
        <br />
        <div className="pds-dataTable-table-container">
          <table
            className="pds-table pds-table-bordered pds-table-hoverable-rows pds-table-container"
            id="fcListing"
            aria-live="polite"
          >
            <thead>
              <tr>
                <th className="sort pds-dataTable-table-header" scope="col" data-sort="pds-dataTable-sort-fname" datadefaultorder='desc' colSpan="1">
                  <strong>First Name</strong>
                </th>
                <th className="sort pds-dataTable-table-header" scope="col" data-sort="pds-dataTable-sort-lname" datadefaultorder='desc' colSpan="1">
                  <strong>Last Name</strong>
                </th>
                <th className="sort pds-dataTable-table-header" scope="col" data-sort="pds-dataTable-sort-eid" datadefaultorder='desc' colSpan="1">
                  <strong>EID</strong>
                </th>
                <th  scope="col"  colSpan="1">
                  <strong></strong>
                </th>
              </tr>
            </thead>
            <tbody>
              {firmContacts.map((x, index) => {

                return (
                  <FirmContactRow
                    user={props.user}
                    name={x.name}
                    firmEid={eid}
                    eid={x.eid}
                    key={index}
                    setFcDisplayResponse={props.setFcDisplayResponse}
                    setSpinnerActive={props.setSpinnerActive}
                  />
                );

              })}
            </tbody>
          </table>
        </div>
      </div>
      <button
        className="pds-button pds-button-primary"
        data-gtm="modal-cta"
        id="buildFNewFcButton"
        onClick={handleAdd}
        >
        {`${action}`}
      </button>
      &nbsp;
      <button
        className="pds-button pds-button-secondary"
        data-gtm="modal-cta"
        id="firmSearchButton"
        onClick={handleSubmit}
      >
        Return to firm search
      </button>
    </div>
  );
}